import ReactDOM from 'react-dom/client';

import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: 'https://cc209fc4ee61e4aee186e1aa74a51935@o4507644678569984.ingest.de.sentry.io/4509762881912912',
	sendDefaultPii: true,
});

const mountPoint = document.querySelector<HTMLDivElement>('div[data-hook="3453_0"]');

if (!mountPoint) {
	throw new Error('Missing mount point!');
} else {
	import('./application')
		.then(({ Application }) => {
			ReactDOM.createRoot(mountPoint).render(<Application />);
		})
		.catch((error) => {
			console.error('Error loading the application:', error);
		});
}
